import { Box, Text } from '@factorialco/deprecated-design-system'
import { PersonAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { LocalUserChoices } from '@livekit/components-react'
import { LocalTrack } from 'livekit-client'

import buildUrl from 'modules/core/lib/buildUrl'

interface VideoContainerProps {
  videoTrack: LocalTrack | undefined
  localUserChoices: LocalUserChoices
  firstName: string
  lastName: string
  avatar: string | undefined | null
  username: string
  videoRef: React.RefObject<HTMLVideoElement>
  facingMode?: string
}

export const VideoContainer = ({
  videoTrack,
  localUserChoices,
  firstName,
  lastName,
  avatar,
  username,
  videoRef,
  facingMode,
}: VideoContainerProps) => {
  // Determine if we need to mirror the video based on facing mode
  const shouldMirror = facingMode !== 'environment'

  return (
    <Box
      style={{
        width: '100%',
        paddingTop: 'calc(3 / 5 * 100%)',
        overflow: 'hidden',
      }}
      alignItems="center"
      justifyContent="center"
      position="relative"
      borderRadius={{ all: 'abs016' }}
      background="grey1000"
    >
      <Box position="absolute" alignItems="center" justifyContent="center" style={{ inset: '0px' }}>
        {videoTrack && localUserChoices.videoEnabled ? (
          <video
            data-lk-facing-mode={facingMode}
            ref={videoRef}
            width="100%"
            height="100%"
            autoPlay
            playsInline
            muted
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
              transform: shouldMirror ? 'scaleX(-1)' : 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        ) : (
          <PersonAvatar
            firstName={firstName}
            lastName={lastName}
            size="large"
            src={buildUrl(avatar)}
          />
        )}
      </Box>

      <Box
        position="absolute"
        paddingX="s12"
        paddingY="s8"
        borderRadius={{ all: 'abs012' }}
        background="grey1000"
        style={{
          top: '16px',
          left: '16px',
          zIndex: '1000',
        }}
      >
        <Text.Normal color="white" weight="bold" size="100">
          {username}
        </Text.Normal>
      </Box>
    </Box>
  )
}
